import React, { Fragment, useEffect, useState } from 'react'
import { Modal, SetStakeWrapper } from './setStakeStyled'
import { SET_STAKE_PROPS } from './interface'
import useStakeOperations from 'functions/stakeOperations/useStakeOperations'
import Container from 'pages/container/Container'
import {
  checkForEmpty,
  checkMaxMin,
  checkOnlyDot,
  checkStartWithZeros,
} from 'components/input/helpers/checkerFunctions'
import SetStakeContent from './SetStakeContent'
export default function SetStakeModalPage({
  balance,
  colors,
  audio,
  gameInfo,
  stake,
  handleStake,
  handleNotification,
  SFX,
  isZero,
  handleModal,
  fadeOut,
  IsInline,
  hasTenX,
  inputLength,
}: SET_STAKE_PROPS) {
  const { minBet, maxBet, precision, currency } = gameInfo

  const [number, setnumber] = useState(stake)
  const [
    finalStake,
    makeMathOperation,
    setfinalStake,
    inputStake,
    setinputStake,
  ] = useStakeOperations(
    number,
    minBet,
    maxBet,
    precision,
    audio,
    handleNotification,
    currency,
    isZero,
  )

  useEffect(() => {
    setnumber(finalStake)
  }, [finalStake])

  const handleSetStake = (b: boolean) => {
    // console.log('handleSetStake', inputStake)
    if (b) {
      if (checkForEmpty(inputStake)) {
        return handleStake(minBet)
      }
      if (checkOnlyDot(inputStake)) {
        return handleStake(minBet)
      }

      const z: string = checkStartWithZeros(inputStake)
      const m = currency
        ? checkMaxMin(
            z,
            maxBet,
            minBet,
            handleNotification,
            currency,
            precision,
            isZero,
          )
        : checkMaxMin(
            z,
            maxBet,
            minBet,
            handleNotification,
            currency,
            precision,
            isZero,
          )
      const f = (+m).toFixed(precision) // todo this tofix dynamic
      handleStake(f)
      setTimeout(() => {
        handleModal(false)
      }, 320)
    }
  }
  const handleAllIn = (allIn: string) => {
    setfinalStake(allIn)
    setinputStake(allIn)
  }
  return (
    <Fragment>
      {IsInline ? (
        <SetStakeWrapper className='set-stake-wrapper'>
          <SetStakeContent
            balance={balance}
            colors={colors}
            audio={audio}
            gameInfo={gameInfo}
            handleNotification={handleNotification}
            SFX={SFX}
            isZero={isZero}
            handleModal={handleModal}
            inputStake={inputStake}
            setnumber={setnumber}
            setinputStake={setinputStake}
            makeMathOperation={makeMathOperation}
            handleAllIn={handleAllIn}
            handleSetStake={handleSetStake}
            hasTenX={hasTenX}
            inputLength={inputLength}
          />
        </SetStakeWrapper>
      ) : (
        <Container
          unBlur={false}
          left='unset'
          top='49%'
          right='unset'
          width='320px'
          height='324px'
          padding='0px'
        >
          <Modal background={colors.primaryDark} fadeOut={fadeOut}>
            <SetStakeContent
              balance={balance}
              colors={colors}
              audio={audio}
              gameInfo={gameInfo}
              handleNotification={handleNotification}
              SFX={SFX}
              isZero={isZero}
              handleModal={handleModal}
              inputStake={inputStake}
              setnumber={setnumber}
              setinputStake={setinputStake}
              makeMathOperation={makeMathOperation}
              handleAllIn={handleAllIn}
              handleSetStake={handleSetStake}
              hasTenX={hasTenX}
            />
          </Modal>
        </Container>
      )}
    </Fragment>
  )
}
